import { render } from "./QuestionCheckbox.vue?vue&type=template&id=de447200"
import script from "./QuestionCheckbox.vue?vue&type=script&lang=js"
export * from "./QuestionCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__